var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),_c('v-row',{staticClass:"content-header"},[_vm._t("header")],2),(_vm.filter)?_c('v-card',{staticClass:"mb-2 px-3",attrs:{"outlined":""}},[_vm._t("filter")],2):_vm._e(),(_vm.noCard)?_c('div',[_vm._t("body")],2):_vm._e(),_vm._t("body-nocard")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }